import { render } from "./settings_user_management_header.html?vue&type=template&id=d9152a2c&scoped=true&external"
import script from "./settings_user_management_header.js?vue&type=script&lang=js&external"
export * from "./settings_user_management_header.js?vue&type=script&lang=js&external"

import "../../Profile/profile_theme.css?vue&type=style&index=0&id=d9152a2c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9152a2c"]])

export default __exports__